import type { FC, ReactNode } from 'react';
import Link, { type LinkProps } from 'next/link';

import { cn } from '@/lib/utils';

export interface SkipLinkProps extends Omit<LinkProps, 'href'> {
    href?: string;
    children?: ReactNode;
}

const SkipLink: FC<SkipLinkProps> = ({ href, children, onClick, ...props }) => (
    <Link
        href={href || ''}
        className={cn(
            'w-full rounded-lg border border-purple-600 bg-purple-100 px-10 py-5 text-center text-sm font-extrabold text-typo-primary sm:w-fit',
            'absolute left-1/2 top-0 z-50 -translate-x-1/2 opacity-0 transition-opacity focus:opacity-100 focus-visible:opacity-100',
            'pointer-events-none focus:pointer-events-auto focus-visible:pointer-events-auto',
        )}
        onClick={e => {
            if (!href) {
                e.preventDefault();
            }
            onClick && onClick(e);
        }}
        {...props}
    >
        {children}
    </Link>
);

export default SkipLink;
